@use '../../styling/form-controls.scss' as *;
@use '../../styling/colors.scss' as *;

.ReadOnlyTextArea {
  @extend %form-control-border;
  @extend %form-control-font;
  @extend %form-control-background;

  padding: 0.5em;
  box-sizing: border-box;
  appearance: none;
  width: 100%;
  caret-color: transparent;
  color: $theme-color-text;

  &::placeholder {
    color: $theme-color-text;
  }
}

.Bordered {
  @extend .ReadOnlyTextArea;

  background-color: $theme-color-input-readonly;
  border-color: $theme-color-input-readonly-border;
  resize: vertical;
}

.Borderless {
  @extend .ReadOnlyTextArea;

  background-color: none;
  border: none;
  resize: none;
}
